<template>
  <v-layout v-if="doc.mime_type === 'application/pdf' && doc.document_state.enum !== 'unlinked'" column class="my-3">
    <v-layout align-end>
      <div class="body-2 grey--text text--darken-1 mb-2 px-2">Assinadores</div>
      <v-btn v-if="isCurrentUserOwnerDocument" flat color="blue" small @click="showSignerDialog = true">
        Alterar
      </v-btn>

      <v-dialog v-model="dialogSign" width="400" persistent>
        <template v-slot:activator="{ on }">
          <v-btn small flat color="blue"
            v-show="currentUserHavePendingSignature && !currentUserHavePendingSignature.signed && documentIsNotDraft"
            @click="dialogSign = true">
            Assinar
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline primary white--text" primary-title>
            Assinar documento
          </v-card-title>

          <v-card-text>
            <span>
              Por favor, insira sua senha para confirmar a assinatura do documento
              <strong>{{ this.doc.document_type.name }}</strong> ,
              criado por
              <strong>{{ this.doc.created_by.name }}</strong>.
            </span>


            <v-text-field label="Senha" v-model="password" type="password" persistent-hint hint="Sua senha de acesso"
              @keypress.enter="signDocument()" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="signDocument()" :loading="isLoading">
              Assinar
            </v-btn>
            <v-btn color="primary" flat @click="dialogSign = false" :disabled="isLoading">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-tooltip bottom :z-index="300">
        <v-btn slot="activator" flat icon small v-if="!isEmpty(last(doc.document_versions).signature_page_file)">
          <a style="text-decoration: none" :href="last(doc.document_versions).signature_page_file" target="_blank">
            <v-icon>mdi-file-download</v-icon>
          </a>
        </v-btn>
        <span> Download da Folha de Assinaturas </span>
      </v-tooltip>

    </v-layout>
    <v-divider />

    <!-- Empty Content -->
    <v-layout column align-center>
      <v-icon v-show="isEmpty(signers)" class="mt-3" color="grey">mdi-transcribe</v-icon>
      <span class="grey--text" v-show="doc.document_state.state === 'Rascunho'">
        Finalize o rascunho para assinar o documento
      </span>
      <span class="grey--text" v-show="doc.document_state.state === 'DocGo' && isEmpty(signers)">
        Ainda não há assinadores para esse documento
      </span>
    </v-layout>

    <!-- Signers -->
    <v-layout class="mt-3">
      <v-tooltip bottom v-for="(item, index) in signers" :key="item.id" :z-index="300">
        <v-avatar class="mr-3" size="32" slot="activator"
          :style="{ boxShadow: `${shadowColorSignatureStatus(item)} 0 0 8px` }" v-if="index <= 7">
          <img v-if="!isEmpty(item.user.avatar.url)" :src="item.user.avatar.url" :alt="item.user.name" />
          <span v-else>{{ acronym(item.user.name) }}</span>
        </v-avatar>

        <span>{{ `${item.user.name} (${signatureStatus(item)})` }}</span>
      </v-tooltip>
      <v-avatar class="mr-1" size="32" v-if="signers.length > 8">
        <strong class="grey--text text--darken-2">
          + {{ signers.length - 8 }}
        </strong>
      </v-avatar>
    </v-layout>

    <add-signer-dialog :doc="doc" :show="showSignerDialog" @toggleAddSignerDialog="showSignerDialog = false" />
  </v-layout>
</template>

<script>
import { isEmpty, find, last } from 'lodash';
import acronym from '@/utils/acronym';
import AddSignerDialog from '@/components/document/show/AddSignerDialog';
import DocumentService from '@/services/DocumentsService';

export default {
  name: 'DocumentSigners',
  components: {
    AddSignerDialog,
  },
  data() {
    return {
      isEmpty,
      acronym,
      last,
      dialogSign: false,
      password: '',
      showSignerDialog: false,
      isLoading: false,
    };
  },
  props: {
    doc: {
      type: Object,
      default: () => { },
    },
  },
  methods: {
    signDocument() {
      this.isLoading = true;

      this.$getLocation()
        .then((coordinates) => {
          DocumentService
            .signDocument(this.doc.id, this.password, `${coordinates.lat}, ${coordinates.lng}`)
            .then(() => {
              this.$store.dispatch('getActiveFolder', { id: this.folder.id, loading: false });
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                color: 'green',
                message: 'Documento Assinado',
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
                messageIcon: 'mdi-check-outline',
              });
            })
            .catch((responseError) => {
              let errorMessage = '';
              if (responseError.response.status === 500) {
                errorMessage = responseError.response.data.message;
              } else {
                errorMessage = responseError.response.data.join(', ');
              }
              this.$store.dispatch('toggleSnackbar', {
                show: true,
                color: 'error',
                message: errorMessage,
                button: { show: true, text: 'Fechar', message: '' },
                timeout: 6000,
                messageIcon: 'mdi-alert-outline',
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.dialogSign = false;
            });
        })
        .catch(() => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'red',
            message: 'Não foi possível obter sua localização. Autorize o seu navegador a obter a localização para continuar',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
            messageIcon: 'mdi-check-outline',
          })
            .finally(() => {
              this.isLoading = false;
            });
        })
        ;
    },
    shadowColorSignatureStatus(signature) {
      let color = '';
      if (signature.signed) {
        color = '#008500';
      } else if (signature.refusal_reason) {
        color = '#ff0000';
      } else {
        color = '#000000';
      }
      return color;
    },
    signatureStatus(signature) {
      let status = '';
      if (signature.signed) {
        status = 'Assinado';
      } else if (signature.refusal_reason && !signature.signed) {
        status = `Recusado - ${signature.refusal_reason}`;
      } else {
        status = 'Aguardando';
      }
      return status;
    },
  },
  computed: {
    signers() {
      const doc = find(this.folder.documents, ['id', this.doc.id]);
      const signers = [...doc.signers];
      return signers;
    },
    folder() {
      return this.$store.getters.activeFolder;
    },
    document() {
      return find(this.folder.documents, ['id', this.doc.id]);
    },
    isCurrentUserOwnerDocument() {
      return this.$store.getters.user.id === this.document.created_by.id;
    },
    currentUserHavePendingSignature() {
      return find(this.signers, s => s.user.id === this.$store.getters.user.id && !s.signed);
    },
    documentIsNotDraft() {
      return this.document.document_state.state !== 'Rascunho' && this.document.document_state.state !== 'Rascunho de Minuta';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/document/show/DocumentSigners.vue